import React, { FC } from 'react';
import styled, { keyframes } from 'styled-components';

interface Props {
  className?: string;
  size?: number;
  thickness?: number;
  color?: string;
  embed?: boolean;
}

const Throbber: FC<Props> = React.memo(props => {
  const {
    className = '',
    size = 50,
    thickness = 2,
    color = '',
    embed = false,
  } = props;

  return (
    <StyledThrobber
      className={className}
      size={size}
      thickness={thickness}
      color={color}
      embed={embed}
    />
  );
});

Throbber.displayName = 'Throbber';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const StyledThrobber = styled.div<Required<Props>>`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: block;
  top: 0;
  left: 0;
  ${props => `${props.embed ? `position: relative;` : `position: absolute;`}`}

  ::before {
    width: ${props => `${props.size}px`};
    height: ${props => `${props.size}px`};
    content: '';
    position: absolute;
    border-radius: 100%;
    top: calc(50% - ${({ size, thickness }) => `${size / 2 + thickness}px`});
    left: calc(50% - ${({ size }) => `${size / 2}px`});
    border: solid;
    border-width: ${props => `${props.thickness}px`};
    border-color: ${props =>
      props.color
        ? props.theme?.colors?.[props.color] || props.color
        : props.theme?.colors?.white};
    border-left-color: rgba(255, 255, 255, 0.3);
    border-bottom-color: rgba(255, 255, 255, 0.3);
    animation: ${spin} 0.5s linear infinite;
  }
`;

export default Throbber;
